import TermsAndConditions from '../../src/client/pages/terms-and-conditions';

export default TermsAndConditions;
